module.exports = __webpack_public_path__ + "44f9eb1cbed5509cfa63ce4af5d44ba8.png";